import { useState } from "react";

import * as Api from "@/api";
import Avatar from "@/design/components/Avatar";
import Valkyrie, { viBel, viSpinnerThird, viTrashCan } from "@sippy-platform/valkyrie";

import { Card, IconButton, List, ListItem, ListItemAvatar, ListItemButton, ListItemText } from "@mui/material";
import PropTypes from "prop-types";

function DistinctiveRingtoneItem({ user, dispatch, distinctiveRingtone }) {
  const [pending, setPending] = useState(false);

  const handleDeleteDistinctiveRingtone = () => {
    setPending(true);

    Promise.resolve(Api.deleteUserDistinctiveRingtone(user, distinctiveRingtone))
      .then(() => dispatch({ type: "removeDistinctiveRingtone", distinctiveRingtone }))
      .finally(() => setPending(false));
  };

  return (
    <Card variant="outlined">
      <List>
        <ListItem
          disablePadding
          secondaryAction={
            <IconButton onClick={() => handleDeleteDistinctiveRingtone(distinctiveRingtone)} color="inherit">
              <Valkyrie icon={pending ? viSpinnerThird : viTrashCan} spin={pending} />
            </IconButton>
          }
        >
          <ListItemButton>
            <ListItemAvatar>
              <Avatar text={distinctiveRingtone.name} icon={viBel} />
            </ListItemAvatar>
            <ListItemText primary={distinctiveRingtone.name} />
          </ListItemButton>
        </ListItem>
      </List>
    </Card>
  );
}

DistinctiveRingtoneItem.propTypes = {
  distinctiveRingtone: PropTypes.object,
  user: PropTypes.object,
  dispatch: PropTypes.func,
};

export default DistinctiveRingtoneItem;
